var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 4.7145 4.7145 0 10.5 0C16.2855 0 21 4.7145 21 10.5C21 16.2855 16.2855 21 10.5 21C4.7145 21 0 16.2855 0 10.5ZM5.35627 13.6122V15.6436H7.3876L13.5674 9.46373L11.5361 7.4324L5.35627 13.6122ZM12.7663 6.20215L14.7977 8.23349L15.6274 7.40379C15.78 7.2512 15.8563 7.05092 15.8563 6.80297C15.8563 6.55501 15.78 6.35474 15.6274 6.20215L14.7977 5.37245C14.6451 5.21986 14.4448 5.14357 14.1969 5.14357C13.9489 5.14357 13.7486 5.21986 13.5961 5.37245L12.7663 6.20215Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditView);
export default __webpack_public_path__ + "static/media/edit-view.31d0d50c4eecc6d266617de4f116e9aa.svg";
export { ForwardRef as ReactComponent };